import React       from 'react';
import styled      from 'styled-components';
import { Grid }    from '@material-ui/core';
import { ICardAd } from '@typings/nationalAdManagement';

interface IAdDetailsProps {
  adData: Partial<ICardAd>;
}

const DetailsContainer = styled.div`
  padding          : 20px;
  background-color : #FFF;
  border-radius    : 0 0 5px 5px;
`;

const DetailsItem = styled.div`
  display   : flex;
  font-size : 16px;
  color     : #646464;
`;

const Title = styled.span`
  flex-basis: 80px;
`;

const Value = styled.span`
  font-weight: 100;
`;

const InfoWrapper = styled.div`
  padding: 0 8px;
`;

export const AdDetails = ({ adData }: IAdDetailsProps): JSX.Element => (
  <DetailsContainer>
    <InfoWrapper>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DetailsItem>
            <Title>Views:</Title>
            <Value>{adData.views}</Value>
          </DetailsItem>
        </Grid>

        <Grid item xs={6}>
          <DetailsItem>
            <Title>Visits:</Title>
            <Value>{adData.visits}</Value>
          </DetailsItem>
        </Grid>

        <Grid item xs={6}>
          <DetailsItem>
            <Title>Running:</Title>
            <Value>{adData.isActive ? 'Yes' : 'No'}</Value>
          </DetailsItem>
        </Grid>

        <Grid item xs={6}>
          <DetailsItem>
            <Title>Clickable:</Title>
            <Value>{adData.isClickable ? 'Yes' : 'No'}</Value>
          </DetailsItem>
        </Grid>
      </Grid>
    </InfoWrapper>
  </DetailsContainer>
);
